module.exports = __webpack_public_path__ + "img/eye-solid.d7bae75d.svg";